// src/features/dataSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

// Async thunk to fetch data from API
export const forgotPassword = createAsyncThunk(
  "forgot/forgotPassword",
  async (data) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/user/forgot-password`,
        data,
      );
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  },
);

const forgotSlice = createSlice({
  name: "forgot",
  initialState: {
    forgotpassword: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(forgotPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.forgotpassword = action.payload;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default forgotSlice.reducer;
